<script>
    export let episodes = [];
    export let onEpisodeClick = () => {};
</script>

<div class="episode-grid">
    {#each episodes as episode, index}
        <div
            class="episode-card"
            on:click={() => onEpisodeClick(index)}
            on:keydown={(e) => e.key === 'Enter' && onEpisodeClick(index)}
            role="button"
            tabindex="0"
            aria-label="{episode.name.split(' ')[1]} {`Open ${episode.label || episode.name}`}"
        >
            <div class="card-image">
                {#if episode.featuredImage}
                    <img src={episode.featuredImage} alt={episode.name} />
                {:else}
                    <div class="placeholder-image">
                        <span>{episode.name}</span>
                    </div>
                {/if}
                {#if episode.hasSubEpisodes}
                    <span class="sub-badge">{episode.subEpisodes.length} Folgen</span>
                {/if}
            </div>
            <div class="card-title">
                <h3>{episode.name.split(' ')[1]} {episode.label || episode.name}</h3>
            </div>
        </div>
    {/each}
</div>

<style>
    .episode-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 2rem;
        margin-bottom: 100px;
        padding: 1rem;
    }

    @media (min-width: 768px) {
        .episode-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (min-width: 1024px) {
        .episode-grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media (min-width: 1440px) {
        .episode-grid {
            grid-template-columns: repeat(4, 1fr);
        }
    }

    .episode-card {
        cursor: pointer;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition:
            transform 0.2s,
            box-shadow 0.2s;
        background: white;
    }

    .episode-card:hover,
    .episode-card:focus {
        transform: translateY(-4px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        outline: 2px solid #ff3e00;
        outline-offset: 2px;
    }

    .card-image {
        position: relative;
        width: 100%;
        aspect-ratio: 1/1;
        background: #f0f0f0;
    }

    .card-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .placeholder-image {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        font-weight: bold;
        font-size: 1.5rem;
    }

    .sub-badge {
        position: absolute;
        top: 1rem;
        right: 1rem;
        background: rgba(255, 62, 0, 0.9);
        color: white;
        padding: 0.25rem 0.75rem;
        border-radius: 999px;
        font-size: 0.85rem;
        font-weight: 600;
    }

    .card-title {
        padding: 1rem;
        background: white;
    }

    .card-title h3 {
        margin: 0;
        font-size: 1.25rem;
        color: #333;
    }
</style>
